import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import "./NewDashboard.css";

// Site chrome
import Header from "../../Components/Header/Header";
import Footer from "../../Components/Footer/Footer";
import SearchPlayersSlider from "../../Components/SearchPlayersSlider/SearchPlayersSlider";

export default function NewDashboard() {
  useEffect(() => {
    document.title = "NIL-Collab";
    const meta = document.querySelector('meta[name="description"]');
    if (meta) {
      meta.setAttribute(
        "content",
        "A national NIL platform connecting fans, brands, and athletes. Support athletes, start brand partnerships, and build athlete profiles."
      );
    }
  }, []);

  return (
    <div>
      {/* Global Header */}
      <Header />

      {/* Hero */}
      <header className="intro-section">
        <div className="intro-inner">
          <h1>
            {" "}
            <span className="dash-orange-colpr-text">
              Empowering
            </span> Athletes.{" "}
            <span className="dash-orange-colpr-text"> Connecting</span> Fans.
            <span className="dash-orange-colpr-text"> Growing </span> Brands.
          </h1>
          <p>
            Connect, engage, and grow with a Name, Image, and Likeness (NIL)
            marketplace that brings fans, brands, and athletes together.
            <br></br>
            <strong className="dash-orange-colpr-text">
              {" "}
              Results powered by athlete influence.
            </strong>
          </p>
          <small>
            Trusted by athletes nationwide • NCAA-compliant and built for your
            success
          </small>
        </div>
      </header>

      <SearchPlayersSlider />
      {/* How It Works (inside a light grey box) */}
      <section className="section howitworks">
        <div className="howitworks-box">
          <h2>How It Works</h2>

          <div className="cards">
            {/* Card 1 */}
            <article className="card">
              <h3>For Fans &amp; Supporters</h3>
              <Link
                className="button"
                to="/dashboard/start-your-fan-experience"
              >
                Start Your Fan Experience
              </Link>
              <br></br>
              <p>
                Connect with Your Favorite Athlete and Elevate Your Social Media
                Game.
              </p>
              <small>
                Partnering with your favorite athlete boosts your social
                presence by leveraging their influence, credibility, and
                lifestyle to grow your reach, increase engagement, and connect
                with a wider, more loyal audience.
              </small>
            </article>

            {/* Card 2 */}
            <article className="card">
              <h3>For NIL Brands</h3>
              <Link
                className="button"
                to="/dashboard/start-your-brand-partnership"
              >
                Start Your Brand Partnership
              </Link>
              <br></br>

              <p>Want to amplify your brand and reach a wider audience?</p>
              <small>
                Partner with athletes who deliver real results. With social
                followings in the hundreds of thousands or even millions, they
                bring visibility, credibility, and lifestyle influence that
                elevate your brand, build trust, and drive measurable
                conversions.
              </small>
            </article>

            {/* Card 3 */}
            <article className="card">
              <h3>For Athletes</h3>
              <Link className="button" to="/CreateAthleteProfile">
                Build Your NIL Profile
              </Link>
              <br></br>

              <p>
                Get Recognized. Get Supported. Get Growing. Create your NIL
                profile today and unlock sponsorships, contributions, and
                opportunities.
              </p>
              <small>
                Join thousands of athletes building their NIL profile today
              </small>
            </article>
          </div>
        </div>
      </section>

      {/* Global Footer */}
      <Footer />
    </div>
  );
}
